var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KeyValue',{attrs:{"add-label":_vm.t('storageClass.longhorn.addLabel'),"read-allowed":false,"mode":_vm.mode},model:{value:(_vm.value.parameters),callback:function ($$v) {_vm.$set(_vm.value, "parameters", $$v)},expression:"value.parameters"}})
}
var staticRenderFns = []

export { render, staticRenderFns }